import { IconProps } from "../../../types/style";

const KeyShieldSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M19.0398 4.16989L13.5398 2.10989C12.9698 1.89989 12.0398 1.89989 11.4698 2.10989L5.9698 4.16989C4.9098 4.56989 4.0498 5.80989 4.0498 6.93989V15.0399C4.0498 15.8499 4.5798 16.9199 5.2298 17.3999L10.7298 21.5099C11.6998 22.2399 13.2898 22.2399 14.2598 21.5099L19.7598 17.3999C20.4098 16.9099 20.9398 15.8499 20.9398 15.0399V6.93989C20.9498 5.80989 20.0898 4.56989 19.0398 4.16989ZM13.2498 12.8699V15.4999C13.2498 15.9099 12.9098 16.2499 12.4998 16.2499C12.0898 16.2499 11.7498 15.9099 11.7498 15.4999V12.8699C10.7398 12.5499 9.9998 11.6099 9.9998 10.4999C9.9998 9.11989 11.1198 7.99989 12.4998 7.99989C13.8798 7.99989 14.9998 9.11989 14.9998 10.4999C14.9998 11.6199 14.2598 12.5499 13.2498 12.8699Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default KeyShieldSVG;
